import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function ThankYouPage() {
  return (
    <>
      <Navbar variant="light" />
      
      <section className="thank-you-section" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="container">
          <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
            
            {/* Success Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              margin: '0 auto var(--space-2xl)',
              background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 10px 30px rgba(6, 182, 212, 0.3)'
            }}>
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>

            {/* Title */}
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontSize: '2.5rem',
              fontWeight: '700',
              color: 'var(--text-dark)',
              marginBottom: 'var(--space-xl)',
              lineHeight: '1.2'
            }}>
              Mulțumim pentru completarea formularului!
            </h1>

            {/* Description */}
            <p style={{
              fontSize: '1.125rem',
              color: 'var(--text-medium)',
              marginBottom: 'var(--space-3xl)',
              lineHeight: '1.6',
              maxWidth: '500px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              Formularul tău a fost trimis cu succes. Echipa noastră te va contacta în cel mai scurt timp pentru a confirma programarea.
            </p>

            {/* CTA Button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Link to="/" className="btn btn-primary btn-large" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 'var(--space-sm)'
              }}>
                Înapoi la homepage
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '4px' }}>
                  <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default ThankYouPage;




